module.exports = __webpack_public_path__ + "static/media/recherche-small.d8dab1fb.png";